import type { Languages } from 'bundles/unified-description-page-common/providers/LanguageInfoDialogProvider';

const getLanguagesMetadata = (languages: Languages) => {
  const originalLanguage = languages.primaryLanguages[0];
  const autoTranslations = languages.translatedLanguages
    .filter((lang) => lang.isMachineTranslated && lang.code !== originalLanguage)
    .map((lang) => lang.code);
  const humanTranslations = languages.translatedLanguages
    .filter((lang) => !lang.isMachineTranslated && lang.code !== originalLanguage)
    .map((lang) => lang.code);
  const fullTranslations = [originalLanguage, ...autoTranslations, ...humanTranslations];
  // Get the subtitles, but remove the languages that have full translations
  const subtitles = languages.subtitleLanguages.filter((lang) => !fullTranslations.includes(lang));
  const dubbedLanguages = languages?.dubbedLanguages?.map((lang) => lang.languageCode) ?? [];

  return {
    originalLanguage,
    autoTranslations,
    humanTranslations,
    subtitles,
    dubbedLanguages,
  };
};

export default getLanguagesMetadata;
